import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { useSettingMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { PaymentTerm } from "@faire/web-api--source/indigofair/data/PaymentTerm";

const usePaymentTermControl = () => {
  const {
    paymentOnShipmentTerm,
    paymentTermData,
    maximumAvailablePaymentTerm,
    maximumAvailablePaymentTermData,
    paymentTerm,
    isRetailerOnNetTerms,
    isRetailerQualifiedForTerms,
    isRetailerPreQualifiedForLimitIncrease,
  } = useRetailerStore([
    "paymentOnShipmentTerm",
    "paymentTermData",
    "maximumAvailablePaymentTerm",
    "maximumAvailablePaymentTermData",
    "paymentTerm",
    "isRetailerOnNetTerms",
    "isRetailerQualifiedForTerms",
    "isRetailerPreQualifiedForLimitIncrease",
  ]);

  return {
    paymentOnShipmentTerm,
    paymentTermData,
    maximumAvailablePaymentTerm,
    maximumAvailablePaymentTermData,
    paymentTerm,
    isRetailerOnNetTerms,
    isRetailerQualifiedForTerms,
    isRetailerPreQualifiedForLimitIncrease,
  };
};

const usePaymentTermTreatment = () => {
  const { retailer } = useRetailer();

  const paymentOnShipmentTermData = retailer?.payment_on_shipment_term_data;
  const paymentOnShipmentTerm =
    paymentOnShipmentTermData?.payment_term ?? PaymentTerm.PAYMENT_ON_SHIPMENT;

  const paymentTermData = retailer?.payment_term_data;

  const maximumAvailablePaymentTerm =
    (retailer && retailer.maximum_available_payment_term) ||
    PaymentTerm.UNSPECIFIED;

  const maximumAvailablePaymentTermData =
    retailer?.maximum_available_payment_term_data;

  const getPaymentTerm = () => {
    const paymentTerm =
      (retailer && retailer.payment_term) || PaymentTerm.UNSPECIFIED;
    if (paymentTerm === PaymentTerm.HOLD_ON_PLACEMENT) {
      return PaymentTerm.PAYMENT_ON_SHIPMENT;
    }
    return paymentTerm;
  };

  const isRetailerQualifiedForTerms = retailer?.qualified_for_terms ?? false;
  const isRetailerOnNetTerms =
    (isRetailerQualifiedForTerms &&
      retailer?.maximum_available_payment_term_data?.is_net_terms) ??
    false;
  const isRetailerPreQualifiedForLimitIncrease =
    retailer?.net_terms?.pre_qualified_for_limit_increase ?? false;

  return {
    paymentOnShipmentTerm,
    paymentTermData,
    maximumAvailablePaymentTerm,
    maximumAvailablePaymentTermData,
    paymentTerm: getPaymentTerm(),
    isRetailerOnNetTerms,
    isRetailerQualifiedForTerms,
    isRetailerPreQualifiedForLimitIncrease,
  };
};

export const usePaymentTerm = () => {
  const shouldUseHooksMigration = useSettingMigrateRetailerStore();
  if (shouldUseHooksMigration) {
    // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
    return usePaymentTermTreatment();
  }
  // eslint-disable-next-line react-compiler/react-compiler, react-hooks/rules-of-hooks
  return usePaymentTermControl();
};
